import { useTranslation } from 'react-i18next';

import LotteryListResponse from '../Api/SiteApi/Response/LotteryListResponse';

import {
    isLottoplayCoUk,
    isLttry,
    isMML,
    isArabia,
    isPlayport,
    isLottoAmerica,
    isBig5Lottery,
    isDragonLotto24, isThankYouLotto
} from './template';

import Lottery from 'Api/Models/Lottery';

export function getLotteryPlayButtonText(lottery: Lottery | LotteryListResponse, isPlayPage?: string) {
    const { t } = useTranslation();

    if (isPlayPage === '1') {
        switch (true) {
            case isMML():
            case isBig5Lottery():
            case isDragonLotto24():
                return t('lotteryList.playOnline');
            case isArabia() || isPlayport() || isLottoAmerica():
            case isThankYouLotto():
                return t('lotteryList.playNow');
            default:
                return `${t('lotteryList.play')} ${lottery.name}`;
        }
    } else {
        switch (true) {
            case isLttry() || isPlayport() || isLottoAmerica():
            case isThankYouLotto():
                return t('lotteryList.playNow');
            case isMML():
            case isBig5Lottery():
            case isDragonLotto24():
                return t('lotteryList.playOnline');
            case isLottoplayCoUk():
                return t('lotteryList.playNow');
            default:
                return `${t('lotteryList.play')} ${lottery.name}`;
        }
    }
}

export function getLoginButtonLabel() {
    return process.env.MIX_FORM_LOGIN_BUTTON_LABEL ? process.env.MIX_FORM_LOGIN_BUTTON_LABEL : '_i(Login)';
}
